var r=function(r,t){for(var e=-1,n=t.length,a=r.length;++e<n;)r[a+e]=t[e];return r};export{r as default};
//# sourceMappingURL=_arrayPush.js.map
